module.exports = __webpack_public_path__ + "user.3820a9bd.svg";